import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { Button, Card, CardBody, Col, Container, Form, FormGroup, Row } from 'reactstrap';
import Select from "react-select";

//Context
import { useAuth } from "../../context/auth.js";
import { showMessage } from 'services/message.js';
import { api_PUT } from 'services/api_service';
import { api_POST } from 'services/api_service.js';

export default function IdentificacaoTaxaFislurb({
    item,
    opcao,
    handleProximoStep,
    handleReturn,
    setupSolicitacao
}) {
    const { session, setLoading } = useAuth();

    const [optionsTipoDeEmpresa] = useState([
        { label: "SELECIONE", value: "0" },
        { value: "Concessionário", label: "Concessionário" },
        { value: "Autorizatário", label: "Autorizatário" },
        { value: "Credenciado", label: "Credenciado" }
    ]);

    const [optionsFaixaValores] = useState([
        { label: "SELECIONE", value: "0" },
        { value: "Até R$ 100.000,00", label: "Até R$ 100.000,00" },
        { value: "Entre R$ 100.000,00 e R$ 1.000.000,00", label: "Entre R$ 100.000,00 e R$ 1.000.000,00" },
        { value: "Entre R$ 1.000.000,00 e R$ 10.000.000,00", label: "Entre R$ 1.000.000,00 e R$ 10.000.000,00" },
        { value: "Acima de R$ 10.000.000,00", label: "Acima de R$ 10.000.000,00" }
    ]);

    const { register, handleSubmit, setValue, errors, control, watch } = useForm({
        mode: "onBlur",
        defaultValues: {
            tipoDeEmpresa: optionsTipoDeEmpresa[0] || {
                label: "SELECIONE",
                value: "0",
            },
            faixaValores: optionsFaixaValores[0] || {
                label: "SELECIONE",
                value: "0",
            },
        }
    });

    // Categoria
    const [categoria, set_categoria] = useState(null);
    const [setupSolicitacaoAcao, set_setupSolicitacaoAcao] = useState(null);
    const [registro, setRegistro] = useState(null);

    function loadItemProtocolo() {
        if (item != null) {
            set_setupSolicitacaoAcao(item.setupSolicitacaoAcaoNovoCadastro);
            set_categoria(item.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria);
        }
    }

    function loadItemRequerimento() {
        if (item != null) {
            set_setupSolicitacaoAcao(item.setupSolicitacaoAcao);
            set_categoria(item.setupSolicitacaoAcao.setupSolicitacao.categoria);

            const tipoEmpresa = optionsTipoDeEmpresa.find(opt => opt.value === item?.requerimentoTaxaFislurb[0]?.tipoEmpresa);
            const faixaValores = optionsFaixaValores.find(opt => opt.value === item?.requerimentoTaxaFislurb[0]?.faixaValores);

            setValue("tipoDeEmpresa", tipoEmpresa || optionsTipoDeEmpresa[0], { shouldValidate: true });
            setValue("faixaValores", faixaValores || optionsFaixaValores[0], { shouldValidate: true });
        }
    }

    // Observar valor de tipoDeEmpresa
    const tipoDeEmpresa = watch("tipoDeEmpresa");

    function handleCriarObjetoTipoRequerimento(data) {
        const taxaFislurb = registro?.requerimentoTaxaFislurb?.[0];
        const requerimento_Id = registro.requerimento_Id;

        return {
            ...taxaFislurb,
            requerimentoTaxaFislurb_Id: taxaFislurb?.requerimentoTaxaFislurb_Id ?? 0,
            requerimento_Id: requerimento_Id,
            tipoEmpresa: data.tipoDeEmpresa.value,
            faixaValores: data.tipoDeEmpresa.value === "Permissionário de coleta seletiva" ? null : data.faixaValores.value
        };
    }

    async function onSubmit(data) {
        if (!data?.tipoDeEmpresa?.value || data.tipoDeEmpresa.value === "0") {
            return showMessage("Aviso", "Selecione um tipo de empresa, por favor!", "warning", null);
        }

        if (data.tipoDeEmpresa.value !== "Permissionário de coleta seletiva" &&
            (!data.faixaValores?.value || data.faixaValores.value === "0")) {
            return showMessage("Aviso", "Selecione a faixa de valores, por favor!", "warning", null);
        }

        const isRequerimento = opcao.tipoCadastro === "Requerimento";

        if (isRequerimento) {
            const objRequerimento = handleCriarObjetoTipoRequerimento(data);
            setLoading(true);

            try {
                let resposta;

                if (!objRequerimento.requerimentoTaxaFislurb_Id) {
                    resposta = await api_POST(
                        "Requerimento/PostRequerimentoTaxaFislurb",
                        objRequerimento
                    );
                } else {
                    resposta = await api_PUT(
                        "Requerimento/PutRequerimentoTaxaFislurb",
                        objRequerimento
                    );
                }

                const taxaFislurb = resposta?.data;
                const registroAtualizado = { ...registro };

                if (registroAtualizado.requerimentoTaxaFislurb[0]) {
                    registroAtualizado.requerimentoTaxaFislurb = [taxaFislurb];
                }

                handleProximoStep(registroAtualizado);

            } catch (error) {
                showMessage("Erro", error?.message ?? "Error na operação", "error", null);
            } finally {
                setLoading(false);
            }
        }
    }


    useEffect(() => {
        if (item) {
            setRegistro(item);
            if (opcao.tipoCadastro === "Protocolo") loadItemProtocolo();
            else if (opcao.tipoCadastro === "Requerimento") loadItemRequerimento();
        }
    }, [item]);

    return (
        <>
            <div>
                <Card className={`card-stats`}>
                    <CardBody>
                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <h2 className="titulo-solicitacao">Identificação </h2>
                            <Container style={{ maxWidth: "1000px", margin: "0px auto" }}>
                                <Row>
                                    <Col md="12">
                                        <div className="formPrincipal">
                                            <h4
                                                style={{
                                                    borderBottom: "solid 1px #ccc",
                                                    width: "100%",
                                                }}
                                            >
                                                Identificação Taxa FisLurb
                                            </h4>
                                            <h6
                                                Style={{ padding: 0, margin: 0 }}
                                                className="text-center"
                                            >
                                                {categoria && categoria.descricao}
                                            </h6>
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="12">
                                        <div className="formPrincipal">
                                            <Form>
                                                <Row>
                                                    <Col md="12" lg={tipoDeEmpresa.value === "Permissionário de coleta seletiva" ? 12 : 6}>
                                                        <FormGroup>
                                                            <b>
                                                                <label>Tipo de Empresa</label>
                                                            </b>
                                                            <Controller
                                                                name="tipoDeEmpresa"
                                                                control={control}
                                                                rules={{
                                                                    required: session === null &&
                                                                        setupSolicitacaoAcao &&
                                                                        setupSolicitacaoAcao.setupSolicitacao
                                                                            .categoria.sigla === "RSS"
                                                                }}
                                                                as={
                                                                    <Select
                                                                        options={optionsTipoDeEmpresa}
                                                                        placeholder="Selecione"
                                                                    />
                                                                }
                                                            />
                                                            {errors.tipoDeEmpresa && (
                                                                <span className="form-control-label text-danger">
                                                                    * Campo Obrigatório
                                                                </span>
                                                            )}
                                                        </FormGroup>
                                                    </Col>
                                                    {tipoDeEmpresa.value !== "Permissionário de coleta seletiva" &&
                                                        <Col md="12" lg={6}>
                                                            <FormGroup>
                                                                <b>
                                                                    <label>Faixa de Valores</label>
                                                                </b>
                                                                <Controller
                                                                    name="faixaValores"
                                                                    control={control}
                                                                    rules={{
                                                                        required: session === null &&
                                                                            setupSolicitacaoAcao &&
                                                                            setupSolicitacaoAcao.setupSolicitacao
                                                                                .categoria.sigla === "RSS"
                                                                    }}
                                                                    as={
                                                                        <Select
                                                                            options={optionsFaixaValores}
                                                                            placeholder="Selecione"
                                                                        />
                                                                    }
                                                                />
                                                                {errors.faixaValores && (
                                                                    <span className="form-control-label text-danger">
                                                                        * Campo Obrigatório
                                                                    </span>
                                                                )}
                                                            </FormGroup>
                                                        </Col>}
                                                </Row>
                                                <div className="d-flex justify-content-center align-items-center">
                                                    {session != null &&
                                                        session.tipoAcesso == "AreaRestrita" &&
                                                        session.usuario_Id != null && (
                                                            <Col md="4">
                                                                <Button
                                                                    color="secundary"
                                                                    onClick={() => handleReturn(item)}
                                                                    className="btn-mobile"
                                                                    type="submit"
                                                                >
                                                                    <i className="fas fa-chevron-left"></i> Voltar
                                                                </Button>
                                                            </Col>
                                                        )}
                                                    <Button
                                                        color="success"
                                                        className="btn-mobile"
                                                        type="submit"
                                                    >
                                                        Próxima Etapa <i className="fas fa-chevron-right"></i>
                                                    </Button>
                                                </div>
                                            </Form>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </Form>
                    </CardBody>
                </Card>
            </div>
        </>
    )
}
